import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { ControlBuilder } from '../../models/builders/control.builder';
import { Control } from '../../models/control';

const controlBody = (control: Control) => ({
  name: control.name,
  protocol: control.protocol
});

@Injectable()
export class ControlApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }controls`;
  }

  createControl(control) {
    return this.httpClient.post(this.apiUrl, controlBody(control)).pipe(map(ControlBuilder.fromJson));
  }

  deleteControl(control: Control) {
    return this.httpClient.delete(`${ this.apiUrl }/${ control.hash }`);
  }

  getControls() {
    return this.httpClient.get(`${ this.apiUrl }`).pipe(map(ControlBuilder.fromList));
  }

  getControl(hash: string) {
    return this.httpClient.get(`${ this.apiUrl }/${ hash }`)
      .pipe(
        map(ControlBuilder.fromJson)
      );
  }

  updateControl(control: Control) {
    return this.httpClient.put(`${ this.apiUrl }/${ control.hash }`, controlBody(control));
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/control-api.service.ts